import React from 'react';
import { Link } from 'react-router-dom';
import styles from '../../landingPage/home.module.css';

function TermsAndConditions() {
  return (
    <>
      {/* Header */}
      <section className={`${styles.header} ${styles.headerCs}`}>
        <div className={`container ${styles.container}`}>
          <div className={styles.logo}>
            <Link to="/">
              <img src={window.getPublicUrl("/images/logo-2.svg")} alt="ResuMate Logo" />
            </Link>
          </div>
          <div className={styles.social}>
             <ul className='terms-list'>
              <li><a href=""><img src={window.getPublicUrl("/images/insta.svg")} alt="Instagram" /></a></li>
              <li><a href=""><img src={window.getPublicUrl("/images/fb.svg")} alt="Facebook" /></a></li>
              <li><a href=""><img src={window.getPublicUrl("/images/tik.svg")} alt="TikTok" /></a></li>
            </ul>
          </div>
        </div>
      </section>

    <main className="terms-container faq  terms-nd-condition my-3">
      <div  className={`container ${styles.container}`}>
      <header className="terms-header">
        <h1 className='main-heading text-left'>Resumate Terms and Conditions of Use</h1>
        <p>Last Updated: October 1st, 2025</p>
        <p>
          Welcome to Resumate. These Terms and Conditions (“Terms”) govern your access to and use of
          the Resumate mobile application and related services (the “App”). By creating an account or
          using Resumate, you agree to these Terms. If you do not agree, you may not use the App.
        </p>
      </header>

      <article>
        <h2 className='inner-heading'>1. Eligibility</h2>
         <ul className='terms-list'>
          <li>You must be at least 18 years old to use Resumate.</li>
          <li>By using the App, you confirm that you are legally able to enter into this agreement.</li>
          <li>You agree to provide accurate and truthful information when registering and to keep your account details up to date.</li>
        </ul>
      </article>

      <article>
        <h2 className='inner-heading'>2. Account and Registration</h2>
         <ul className='terms-list'>
          <li>To use Resumate, you must create an account with a valid email, phone number, and other required details.</li>
          <li>You are responsible for keeping your login credentials confidential and for all activity on your account.</li>
          <li>If you suspect unauthorized use of your account, you must notify us immediately.</li>
        </ul>
      </article>

      <article>
        <h2 className='inner-heading'>3. Profile and Resume Content (User-Generated Content)</h2>
         <ul className='terms-list'>
          <li>Resumate allows you to create a values-driven profile (“resume”) with personal details, preferences, and open-ended responses.</li>
          <li>You are solely responsible for the accuracy, legality, and appropriateness of the information you provide.</li>
          <li>You must not include sensitive information (financial details, home addresses, government IDs, etc.).</li>
          <li>You retain ownership of your content, but grant Resumate a limited license to use, display, and process it for operating and improving the App.</li>
          <li>Resumate does not endorse or guarantee the accuracy of user content and is not responsible for it.</li>
          <li>Resumate reserves the right to remove or restrict content that violates these Terms or community guidelines.</li>
        </ul>
      </article>

      <article>
        <h2 className='inner-heading'>4. Matching and Interactions</h2>
         <ul className='terms-list'>
          <li>Resumate does not use swiping. Instead, users may send and receive resumes for consideration.</li>
          <li>A chat feature will only open after both users review resumes, hold a video call, and mutually agree to connect.</li>
          <li>You agree to communicate respectfully and not misuse the App for harassment, abuse, or unlawful activity.</li>
        </ul>
      </article>

      <article>
        <h2 className='inner-heading'>5. Prohibited Conduct and Content</h2>
        <p>When using Resumate, you agree that you will not:</p>
         <ul className='terms-list'>
          <li>Use the App for any purpose other than personal, non-commercial use.</li>
          <li>Misrepresent your identity or impersonate another person.</li>
          <li>Upload or share content that is obscene, pornographic, violent, or harmful.</li>
          <li>Promote illegal activity, self-harm, hate speech, threats, or harassment.</li>
          <li>Use the App for spam, scams, or fraudulent activities.</li>
          <li>Interfere with or attempt to compromise the security or functioning of the App.</li>
          <li>Engage in behavior that violates Community Guidelines or undermines user safety.</li>
        </ul>
      </article>

      <article>
        <h2 className='inner-heading'>6. Premium Features and Payments</h2>
         <ul className='terms-list'>
          <li>Resumate may offer optional paid features, such as advanced filters or profile boosts.</li>
          <li>Purchases are handled through third-party app stores.</li>
          <li>Payments are final and non-refundable, except as required by law.</li>
        </ul>
      </article>

      <article>
        <h2 className='inner-heading'>7. Safety and Video Calls</h2>
         <ul className='terms-list'>
          <li>Resumate requires a video call before enabling private chat to help prevent catfishing and increase safety.</li>
          <li>You are solely responsible for your interactions with other users, both online and offline.</li>
          <li>Resumate does not conduct criminal background checks. Use caution and follow safe dating practices.</li>
          <li>Resumate is not responsible for events, actions, or consequences that occur outside the App.</li>
        </ul>
      </article>

      <article>
        <h2 className='inner-heading'>8. Intellectual Property</h2>
         <ul className='terms-list'>
          <li>All rights in the App, including design and features, belong to Resumate.</li>
          <li>You may not copy, modify, or reverse-engineer the App.</li>
          <li>You retain ownership of your content, but grant Resumate a limited license to use it.</li>
        </ul>
      </article>

      <article>
        <h2 className='inner-heading'>9. Termination</h2>
         <ul className='terms-list'>
          <li>You may delete your account at any time.</li>
          <li>Resumate may suspend or terminate accounts that violate these Terms.</li>
          <li>Termination may result in loss of access to your account and data.</li>
        </ul>
      </article>

      <article>
        <h2 className='inner-heading'>10. Disclaimer of Liability</h2>
         <ul className='terms-list'>
          <li>The App is provided “as is” without warranties of any kind.</li>
          <li>We do not guarantee matches or uninterrupted service.</li>
          <li>Resumate is not responsible for damages from use of the App or interactions with other users.</li>
        </ul>
      </article>

      <article>
        <h2 className='inner-heading'>11. Indemnification</h2>
        <p>
          You agree to indemnify and hold harmless Resumate, its affiliates, and staff from any
          claims or damages arising from your use of the App or violation of these Terms.
        </p>
      </article>

      <article>
        <h2 className='inner-heading'>12. Governing Law</h2>
        <p>
          These Terms are governed by the laws of the United States and the State of Arizona. If you
          access the App outside the U.S., you must comply with local laws.
        </p>
      </article>

      <article>
        <h2 className='inner-heading'>13. Changes to Terms</h2>
        <p>
          We may update these Terms periodically. If changes are significant, we will notify you
          through the App or email. Continued use means acceptance of updated Terms.
        </p>
      </article>

      <article>
        <h2 className='inner-heading'>14. Automatic Renewal of Subscriptions</h2>
        <p>
          Paid subscriptions renew automatically unless canceled before the end of the billing
          period. You may manage or cancel through your app store settings. Canceled subscriptions
          remain active until the period ends.
        </p>
      </article>

      <article>
        <h2 className='inner-heading'>15. Dispute Resolution and Arbitration</h2>
         <ul className='terms-list'>
          <li><strong>Agreement to Arbitrate:</strong> Disputes will be resolved by binding arbitration, not court.</li>
          <li><strong>Exceptions:</strong> Small claims and IP-related cases are excluded.</li>
          <li><strong>Individual Basis:</strong> Arbitration is individual; no class actions.</li>
          <li><strong>Waiver of Jury Trial:</strong> Both parties waive the right to a jury trial.</li>
          <li><strong>Opt-Out:</strong> You may opt out by emailing info@resumate.org within 30 days of account creation.</li>
        </ul>
      </article>

      <article>
        <h2 className='inner-heading'>16. Monitoring and Enforcement</h2>
        <p>
          Resumate monitors accounts with tools and human moderators. We may suspend, restrict,
          remove content, or block access to enforce these Terms.
        </p>
      </article>

      <article>
        <h2 className='inner-heading'>17. Privacy</h2>
        <p>
          Your use of Resumate is also governed by our Privacy Policy. By using the App, you agree
          that your data may be processed in accordance with that policy.
        </p>
      </article>

      <article>
        <h2 className='inner-heading'>18. Severability</h2>
        <p>
          If any part of these Terms is found invalid, the remaining sections remain enforceable.
        </p>
      </article>

      <article>
        <h2 className='inner-heading'>19. Entire Agreement</h2>
        <p>
          These Terms, along with our Privacy Policy and Community Guidelines, form the entire
          agreement between you and Resumate.
        </p>
      </article>

      <article>
        <h2 className='inner-heading'>20. Contact Us</h2>
        <p>
          Sparkle from Within LLC<br />
          4539 N 22nd St, Ste N, Phoenix, AZ 85016<br />
          <a className='email' href="mailto:info@resumate.org">info@resumate.org</a>
        </p>
      </article>

      <footer className="terms-footer">
        © {new Date().getFullYear()} Resumate. All rights reserved.
      </footer>
      </div>
    </main>

      {/* Footer */}
      <section className={styles.footer}>
        <div className={`container ${styles.container}`}>
          <div className="row">
            <div className="col-sm-4">
              <div className={styles.footerLeft}>
                <a href=""><img src={window.getPublicUrl("/images/footer-logo.svg")} /></a>
              </div>
                      <div className={`${styles.footerMid} ${styles.right}`}>
                <h4>Follow us</h4>
                 <ul className='terms-list'>
                  <li><a href=""><img src={window.getPublicUrl("/images/footer-social1.svg")} /></a></li>
                  <li><a href=""><img src={window.getPublicUrl("/images/footer-social2.svg")} /></a></li>
                  <li><a href=""><img src={window.getPublicUrl("/images/footer-social3.svg")} /></a></li>
                </ul>
              </div>

            </div>
            <div className="col-sm-4">
                      <div>
                <ul className={styles.termsConditonList}>
                  <li><Link to="/terms&condition">Terms & Conditions</Link></li>
                  <li><Link to="/privacyPolicy">Privacy Policy</Link></li>
                  <li><Link to="/communityGuidelines">Community Guidelines</Link></li>
                  <li><Link to="/eula">EULA</Link></li>
                  <li><Link to="/safety">Safety</Link></li>
                </ul>
              </div>
            </div>
            <div className="col-sm-4">
                  <div className={styles.footerMid}>
                <h4 className="text-right">Get the app</h4>
                <ul className="text-right">
                  <li><a href="https://apps.apple.com/us/app/resumate-app/id6754164064
"><img src={window.getPublicUrl("/images/app2.svg")} /></a></li>
                  <li><a href="https://play.google.com/store/apps/details?id=com.resumate"><img src={window.getPublicUrl("/images/goog2.svg")} /></a></li>                </ul>
              </div>

            </div>
            <div className="col-sm-12">
              <h5>Copyright © 2025 Resumate.  All rights reserved.</h5>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default TermsAndConditions;
